<template>
  <div class="wrapper">
      <div class="content">
          <h1 class="van-hairline--bottom">用户隐私政策</h1>
    <p>欢迎您使用“i襄阳”服务!您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应的安全保护措施，
        尽力保护您的个人信息安全可控。为了给您提供更准确、更有个性化的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息，
        同时本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，
        本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。您在同意本应用服务使用协议之时，
        即视为您已经同意本隐私权政策全部内容。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
    </p>
    <p>请在使用我们的产品（或服务）前，仔细阅读并了解本《用户隐私政策》。</p>
    <h2>1.服务内容。</h2>
    <p>1.1当您在“i襄阳”创建账户成为我们的用户，以便我们为您提供产品和服务，您需要提供手机号码信息，并创建用户名和密码。
        如果您仅需使用基本信息查询、搜索、资讯浏览等基本服务，您不需要注册成为我们的用户及提供上述信息。 您在使用“i襄阳”时，
        需要根据服务的内容，选择填写及/或提交服务所必须的认证信息，可能包括您的姓名、性别、身份信息 （用于身份验证、便民服务、办件查询、
        审批服务等）及相关附加信息（如您所在的省份和城市等，推荐您所在地当地相关的便民服务、资讯）；如果您不使用某些服务，
        则无需提供相关信息。如果您提供真实姓名、身份信息、驾驶证、行驶证等额外的个人资料，我们可以为您提供交通出行、 
        社会保险等更加个性化的会员服务。但这些信息的提供与否，不影响您使用我方平台的基本浏览、搜索、资讯查阅的功能。
    </p>
    <p>1.1.1您向我们提供的信息</p>
    <p>     
        （1）当您使用刷脸登录、验证功能时，我们会收集您的面部信息。您应按照页面的提示完成相应动作，
        “i襄阳”人脸识别工具在判断您的动作符合要求后，即可完成脸部拍摄。
        您同意仅使用您本人的面部信息为您本人所持有的“i襄阳”账户使用刷脸登录、验证服务。为了提高验证的准确性，
        您同意“i襄阳”可在必要时将您向“i襄阳”提供的面部信息与法律法规允许的机构或政府机关授权的机构所保存的您的面部信息进行比对核验。
        如果您不使用刷脸登录功能，则无需提供相关信息。当您使用实名认证功能时，我们会收集您的真实姓名及身份证号信息。
        您应按照页面提示文案输入姓名与身份证号码，您同意“i襄阳”将您向“i襄阳”提供的姓名与身份证号码与法律法规允许的机构或政府机关授权的机构进行比对核验。如果您不使用实名认证功能，则无需提供相关信息。
    </p>
    <p>
        （2）当您使用出入境服务（办事预约、护照报失、户口办理）时，我们会收集您的身份证/护照/签证、国籍/户籍信息，
        您应按页面提示文案输入身份证号码、姓名、护照号码、签证签发日期、有效期、入境时间及入境口岸、国籍或户籍信息，
        您同意“i襄阳”将您向“i襄阳”提供的上述内容与法律法规允许的机构或政府机关授权的机构进行比对核验。如果您不使用出入境服务，
        则无需提供相关信息。
    </p>
    <p>
        （3）当您使用社会保障服务（社保业务查询、社保业务办理、人才服务、劳动关系业务、公积金查询/业务预约），我们会收集您的手机号、性别、
        出生日期、民族、户籍信息、教育信息（毕业年度、毕业学校、院校类别、可获学历、专业、学历类别、生源类别、培养类别）、
        家庭信息（随迁子女数、婚姻状况、子女信息、家属名称、家属证件号、家属关系）、健康信息（疾病类型、请假原因），
        您应按页面提示输入以上内容，您同意“i襄阳”将您向“i襄阳”提供的上述内容与法律法规允许的机构或政府机关授权的机构进行比对核验。
        如果您不使用人社相关服务，则无需提供相关信息。
    </p>
    <p>
        （4）当您使用车辆服务（驾驶证业务、机动车业务、电子保单、汽车摇号/竞价），我们会收集您的手机号、姓名、身份证号、驾驶证档案编号、
        准驾车型、记分、审验时间、体检时间、车牌号码、车牌类型、年审时间，您应按页面提示输入以上内容，
        您同意“i襄阳”将您向“i襄阳”提供的上述内容与法律法规允许的机构或政府机关授权的机构进行比对核验。如果您不使用车辆服务，
        则无需提供相关信息。
    </p>
    <p>
        （5）当您使用医疗服务（预约挂号、附近医院/AED/社康中心/街道办），我们会收集您的手机号、姓名、身份证号、性别、出生年月、地理位置，
        您应按页面提示输入以上内容，您同意“i襄阳”将您向“i襄阳”提供的上述内容与法律法规允许的机构或政府机关授权的机构进行比对核验。
        如果您不使用医疗服务，则无需提供相关信息。
    </p>
    <p>
        （6）当您使用生活缴费（话费、流量、水费、电费、燃气费、油卡），我们会收集您的手机号、业务对应的用户号、电力业务号、油卡卡号，
        您应按页面提示输入以上内容，您同意“i襄阳”将您向“i襄阳”提供的上述内容与法律法规允许的机构或政府机关授权的机构进行比对核验。
        如果您不使用生活缴费，则无需提供相关信息。
    </p>
    <p>
        （7）当您使用政务服务（网上办事大厅、秒批服务、全流程网办、无感申办），我们会收集您的手机号、姓名、身份证号、性别、
        户籍信息（户籍地址、派出所、籍贯）、居住地址、政治面貌、工作单位、社保电脑号、银行卡号，您应按页面提示输入以上内容，
        您同意“i襄阳”将您向“i襄阳”提供的上述内容与法律法规允许的机构或政府机关授权的机构进行比对核验。如果您不使用政务服务，
        则无需提供相关信息。
    </p>
    <p>
        （8）我们还可能会记录您在使用“i襄阳”时提供、形成或留存的信息。
        我们还可能会记录您在使用“i襄阳”办理业务时输入的搜索关键词信息和点击的链接、业务收藏记录。您有权选择不提供前述信息，
        但这将导致您可能无法使用特定服务或功能，或者无法达到相关服务拟达到的效果。
    </p>
    <p>1.1.2我们在您使用服务过程中收集的信息。我们可能会收集关于您使用产品和/或服务（包括使用方式）过程中的信息，此类信息包括：</p>
    <p>
        （1）设备信息
    </p>
    <p>
        为了提供更好的产品和/或服务并改善用户体验，我们会收集常用设备属性信息（例如您的硬件型号）。
        对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。
        我们可能会将您的设备信息或电话号码与您的“i襄阳”帐户相关联。
    </p>
    <p>
        （2）日志信息
    </p>
    <p>
        当您使用“i襄阳”时，我们的服务器会自动记录一些信息，例如您对“i襄阳”的使用情况，包括访问服务的日期、时间、时长等。
    </p>
    <p>
        （3）位置信息
    </p>
    <p>
        当您使用具有定位功能的“i襄阳”应用服务时，当您开启设备定位功能并使用我们基于位置提供的相关服务（导航服务、大厅预约/取号服务、
        办事网点查询）时，我们可能会收集和处理有关您实际所在位置的信息，以使得您不需要手动输入自身地理坐标就可获得相关服务。
        您可以通过关闭定位功能，停止对您的地理位置信息的收集，但您可能将无法获得相关服务或功能，或者无法达到相关服务拟达到的效果。
    </p>
    <p>
        （4）相册信息
    </p>
    <p>
        当您使用图片上传、扫一扫服务时，我们可能会读取您的相册信息，以使得您快速选择上传或读取所需照片。
        您可以通过关闭相册读取权限功能，停止对您的相册信息的收集，但您可能将无法获得相关服务或功能，或者无法达到相关服务拟达到的效果。
    </p>
    <p>
        （5）语音信息
    </p>
    <p>
        当您使用语音搜索服务时，我们可能会读取您的语音信息，以使得您不需要手动输入搜索关键词就可获得相应搜索结果。
        您可以通过关闭麦克风读取权限功能，停止对您的语音信息的收集，但您可能将无法获得相关服务或功能，或者无法达到相关服务拟达到的效果。
    </p>
    <p>
        （6）用户画像信息
    </p>
    <p>
        当您使用APP内服务时，我们将收集您的服务使用频率以及您使用的高频服务事项名称，并根据您在实名认证时提供的身份证号，
        以及您在个人中心设置的个人标签、地址信息、性别、职业信息进行个性化人物画像，以便为您推荐更适合您的服务。
    </p>
    <p>
        （7）电子卡证信息
    </p>
    <p>
        当您使用电子卡证服务时，我们将收集您的卡证非敏感信息(卡号、有效期)，以便为您提供更加快速的访问速度以及证件到期提醒服务。
        您可以通过卡证解绑，停止对您的电子卡证信息的收集，但您可能将无法获得相关服务或功能，或者无法达到相关服务拟达到的效果。
    </p>
    <p>
        （8）通讯录信息
    </p>
    <p>
        当您使用话费充值服务时，我们将收集你的通讯录好友信息，以便您在进行话费充值时，可快速操作充值。您可以通过关闭通讯录读取权限功能，
        停止对您的通讯录信息的收集，但您可能将无法获得相关服务或功能，或者无法达到相关服务拟达到的效果。
    </p>
    <p>
        （9）短信信息
    </p>
    <p>
        当您使用一键报警时，我们将收集您的姓名、身份证号、地理位置信息录入至短信内容，以便您在发送短信时，可以实现快速报警操作。
        当您使用短信分享时，我们将收集您的允许发送短信权限，实现拉起短信分享操作。
    </p>
    <p>
        1.1.3第三方软件开发包（SDK）个人信息收集情况
    </p>
    <p>
        （1）OpenBankSDK开放银行SDK，集成微信、支付宝SDK，无需申请任何权限，未收集任何个人信息，提供银行转账、微信、支付宝付款功能。
    </p>
    <p>
        （2）PushSDK用户中心推送SDK，获取用户账号信息，为用户推送消息。
    </p>
    <p>
        （3）APM移动分析SDK，获取手机信息，用户上报app异常日志。
    </p>
    <p>
        （4）云从科技活体检测SDK。需要申请摄像头权限，收集您的人脸影像信息，提供人脸识别、实名认证功能。
    </p>
    <p>1.2服务的具体内容由“i襄阳”根据实际情况提供。“i襄阳”保留随时变更、中断或终止部分或全部网络服务的权利。目前为注册用户提供以下服务:</p>
    <p>
        （1）办事服务：您可以登录“i襄阳”进行政务服务事项的在线申报，查询办事进度，并对办理情况进行评价。
    </p>
    <p>
        （2）便民服务：您可以在“i襄阳”查阅、办理便民服务，并对便民服务质量进行评价。
    </p>
    <p>
        （3）网上支付：为您提供相关办事事项的在线缴费渠道，可调用第三方支付平台接口实现掌上支付。
    </p>
    <p>
        （4）审批服务：您可以登录“i襄阳”进行行政事项的事项查询、在线审批。
    </p>
    <p>
        （5）用户中心：提供与自然人法人相关的个性化服务，包括网上办件的状态查看、评论内容检索和用户关联，以及热点事项推荐、我的办件、
        证件夹、我的认证等功能。
    </p>
    <h2>2.信息使用。</h2>
    <p>
        2.1本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，
        或该第三方和本应用(含本应用关联公司)单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
    </p>
    <p>
        2.2本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，经发现，
        本应用有权立即终止与该用户的服务协议。
    </p>
    <p>
        2.3为服务用户的目的，本应用可能通过使用您的个人信息，向您提供您感兴趣的信息， 包括但不限于向您发出产品和服务信息，
        或者与本应用合作伙伴共享信息以便他们向您发送有关其产品和服务的信息(后者需要您的事先同意)。
    </p>
    <h2>3.使用规则。</h2>
    <p>
        3.1用户在“i襄阳”注册时，需提供准确的自然人资料，如法人资料有任何变动，请及时更新。
    </p>
    <p>
        3.2用户注册成功后，“i襄阳”将给予每个用户一个用户账号及相应的密码，该用户账号和密码由用户负责保管；
        用户应当对以其用户账号进行的所有活动和事件负法律责任。
    </p>
    <p>
        3.3用户在“i襄阳”注册后，必须遵循以下原则：
    </p>
    <p>
        (1)遵守中国有关的法律和法规;
    </p>
    <p>
        (2)不得为任何非法目的而使用网络服务系统;
    </p>
    <p>
        (3)遵守所有与网络服务有关的网络协议、规定和程序;
    </p>
    <p>
        (4)不得利用“i襄阳”进行任何可能对互联网的正常运转造成不利影响的行为;
    </p>
    <p>
        (5)不得利用“i襄阳”传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料;
    </p>
    <p>
        (6)不得利用“i襄阳”进行任何不利于“i襄阳”的行为;
    </p>
    <p>
        (7)如发现任何非法使用用户账号或账号出现安全漏洞的情况，应立即通告“i襄阳”。
    </p>
    <h2>4.信息披露。</h2>
    <p>
        在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：
    </p>
    <p>
        (1)经您事先同意，向第三方披露;
    </p>
    <p>
        (2)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息;
    </p>
    <p>
        (3)根据法律的有关规定，或者行政或司法机构的要求, 向第三方或者行政、司法机构披露;
    </p>
    <p>
        (4)如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露;
    </p>
    <p>
        (5)如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷;
    </p>
    <p>
        (6)在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的, 
        本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决;
    </p>
    <p>
        (7)其它本应用根据法律、法规或者网站政策认为合适的披露。
    </p>
    <h2>
        5.信息存储和交换。
    </h2>
    <p>
        您在使用“i襄阳”产品及服务期间，我们将持续为您保存您的个人信息。如果您注销帐户或主动删除上述信息，
        我们将依据网络安全法等法律法规规定保存您的信息。在您注销帐户或主动删除上述信息后，我们不会再对您的个人信息进行商业化使用，
        但我们可能会对您的个人信息进行匿名化处理后使用。您的个人信息均储存于中华人民共和国境内。如部分产品或服务涉及跨境，
        我们需要向境外传输您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。

    </p>
    <h2>6.处理未成年人的个人信息。</h2>
    <p>
       “i襄阳”非常重视对未成年人信息的保护。我们的服务主要面向成人。若您是未成年人，建议您请您的监护人仔细阅读本隐私协议，
       并在征得您的监护人同意的前提下使用“i襄阳”。如您的监护人不同意您按照本协议使用我们的服务或向我们提供信息，
       请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。
       如果监护人发现我们在未获监护人同意的情况下收集了未成年人的个人信息，请联系我们，同时提交相关材料以便我们验证身份，
       我们会尽快审核并设法尽快删除相关数据。
    </p>
    <h2>7.内容所有权。</h2>
    <p>
        7.1“i襄阳”提供的网络服务内容可能包括:文字、软件、声音、图片、录象、图表等。所有这些内容受版权、商标和其它财产所有权法律的保护。
    </p>
    <p>
        7.2用户只有在获得“i襄阳”或其他相关权利人的授权之后才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。
    </p>
    <h2>8.隐私保护。</h2>
    <p>
        保护用户隐私是“i襄阳”的一项基本政策，“i襄阳”保证不对外公开或向第三方提供用户注册资料及用户在使用网络服务时存储在“i襄阳”的非公开内容，但下列情况除外:
    </p>
    <p>
        (1)事先获得用户的明确授权;
    </p>
    <p>
        (2)根据有关的法律法规要求;
    </p>
    <p>
        (3)按照相关政府主管部门的要求;
    </p>
    <p>
        (4)为维护社会公众的利益;
    </p>
    <p>
        (5)为维护“i襄阳”的合法权益。
    </p>
    <h2>9.本隐私权政策如何更新。</h2>
    <p>
        我们可能适时会对本隐私权政策进行调整或变更，本隐私权政策的任何更新将以标注更新时间的方式公布在我们网站上，
        除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。
        如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表您已充分阅读、
        理解并接受修改后的隐私权政策并受其约束。
    </p>
    <h2>
        附录1：定义
    </h2>
    <p>
        本隐私协议中使用的特定词语，具有如下含义：
    </p>
    <p>
        1. “我们”或“i襄阳”，指由襄阳市行政审批局主管的移动客户端。
    </p>
    <p>
        2. “您”，指“i襄阳”注册用户。
    </p>
    <p>
        3. “i襄阳”，指“i襄阳”客户端。
    </p>
    <p>
        4. ““i襄阳”关联方、合作方”，指我们的关联公司、合作伙伴及其他受信任的第三方供应商、服务商及代理商。
    </p>
    <p>
        5. “个人信息”，指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
        个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识信息、个人健康生理信息、个人教育工作信息、个人财产信息、
        个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息。为免疑义，个人信息包括但不限于个人敏感信息。
    </p>
    <p>
        6. “个人信息主体”，指个人信息所标识的自然人。
    </p>
    <p>
        7. “个人敏感信息”，指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。
        个人敏感信息包括个人财产信息、个人健康生理信息、个人生物识别信息、个人身份信息、网络身份标识信息。
    </p>
    <p>
        8. “去标识化”，指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。
    </p>
    <p>
        9. “匿名化”，指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。
    </p>
    <p>
        10.“中国”或“中国境内”，指中华人民共和国大陆地区，仅为本隐私协议之目的，不包含香港特别行政区、澳门特别行政区和中国台湾地区。
    </p>
    <div style="height: 24px; width: 100%;" ></div>
      </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.wrapper {
    background: #fff;
     background: #fff;
    overflow: hidden;
    .content{
         padding: 16px;
        height: 100%;
        overflow: scroll;
        -webkit-overflow-scrolling:touch;
        background: #fff;
    }
  h1 {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-bottom: 20px;
    padding-bottom: 4px;
  }
  h2{
      font-size: 16px;
      font-weight: bold;
      line-height: 30px;
      margin-top: 8px;
  }
  h3{
      font-size: 14px;
      font-weight: bold;
      line-height: 30px;
      margin-top: 8px;
  }
  p {
    text-indent: 2em;
    font-size: 12px;
    line-height: 20px;
    color: #999;
    letter-spacing: 1px;
     text-align: justify;
  }
}
</style>